export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_06.3cf563b1.jpg";